import { Home, FileText, ShoppingBag, FolderOpen, User } from "lucide-react";
import { NavLink } from "react-router-dom";

const ITEMS = [
  { to: "/", icon: Home, label: "Home", id: "home" },
  { to: "/services", icon: FileText, label: "Services", id: "services" },
  { to: "/dashboard?tab=orders", icon: ShoppingBag, label: "Orders", id: "orders" },
  { to: "/dashboard?tab=documents", icon: FolderOpen, label: "Documents", id: "documents" },
  { to: "/dashboard?tab=profile", icon: User, label: "Profile", id: "profile" },
];

export function MobileNav() {
  return (
    <nav className="fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-border md:hidden" data-testid="mobile-bottom-nav">
      <div className="grid grid-cols-5">
        {ITEMS.map(({ to, icon: Icon, label, id }) => (
          <NavLink key={id} to={to} end={to === "/"} data-testid={`bottomnav-${id}`}
            className={({ isActive }) => `flex flex-col items-center gap-0.5 py-2 text-[10px] font-medium ${isActive && to === "/" ? "text-primary" : "text-muted-foreground"}`}>
            <Icon size={20} />
            {label}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
